// nav.js

let currentIndex = 0;    // tracks which section is active
let sectionsList = [];   // array of all <section> elements

/**
 * show/hide prev & next buttons based on currentIndex
 */
function updateNavVisibility() {
  const prevBtn = document.querySelector('.menu .prev');
  const nextBtn = document.querySelector('.menu .next');
  const lastIndex = sectionsList.length - 1;

  // hide prev on first, hide next on last
  prevBtn.classList.toggle('hidden', currentIndex === 0);
  nextBtn.classList.toggle('hidden', currentIndex === lastIndex);
}

/**
 * scroll smoothly to the section at the given index,
 * then update button visibility
 */
function scrollToIndex(index) {
  const max = sectionsList.length - 1;
  if (index < 0 || index > max) return;

  currentIndex = index;
  sectionsList[currentIndex].scrollIntoView({ behavior: 'smooth' });
  updateNavVisibility();
}

/**
 * set up click + key listeners for prev/next navigation
 */
function initNav() {
  sectionsList = Array.from(document.querySelectorAll('section'));

  document.querySelector('.menu .next').addEventListener('click', () => {
    scrollToIndex(currentIndex + 1);
  });

  document.querySelector('.menu .prev').addEventListener('click', () => {
    scrollToIndex(currentIndex - 1);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') {
      scrollToIndex(currentIndex + 1);
    } else if (e.key === 'ArrowLeft') {
      scrollToIndex(currentIndex - 1);
    }
  });

  // initial state
  updateNavVisibility();
}

/**
 * Custom "jelly" cursor with arrow rotation on prev/next hover
 */
function customCursor() {
  const isTouchDevice = 'ontouchstart' in window;
  const elasticCursor = document.getElementById("cursor");
  const nextButton    = document.querySelector('.menu .next');
  const prevButton    = document.querySelector('.menu .prev');
  const arrow         = elasticCursor.querySelector('svg');

  const pos = { x: 0, y: 0 };
  const vel = { x: 0, y: 0 };
  let targetPos = { x: 0, y: 0 };
  let isHoveringClickable = false;
  
  // Track transform values
  const cursorTransform = {
    x: 0,
    y: 0,
    rotate: 0,
    scaleX: 0.2,
    scaleY: 0.2
  };

  // Apply all transforms together
  function applyTransform() {
    elasticCursor.style.transform = `
      translate(calc(${cursorTransform.x}px - 50%), calc(${cursorTransform.y}px - 50%)) 
      rotate(${cursorTransform.rotate}deg) 
      scaleX(${cursorTransform.scaleX}) 
      scaleY(${cursorTransform.scaleY})
    `;
  }

  const setX = (value) => {
    cursorTransform.x = value;
    applyTransform();
  };
  
  const setY = (value) => {
    cursorTransform.y = value;
    applyTransform();
  };
  
  const setRotation = (value) => {
    cursorTransform.rotate = value;
    applyTransform();
  };
  
  const setScaleX = (value) => {
    cursorTransform.scaleX = value;
    applyTransform();
  };
  
  const setScaleY = (value) => {
    cursorTransform.scaleY = value;
    applyTransform();
  };

  function getScale(dx, dy) {
    const dist = Math.hypot(dx, dy);
    return Math.min(dist / 100, 0.25);
  }
  
  function getAngle(dx, dy) {
    return Math.atan2(dy, dx) * 180 / Math.PI;
  }

  function update() {
    const rotation = getAngle(vel.x, vel.y);
    const scale = getScale(vel.x, vel.y);

    setX(pos.x);
    setY(pos.y);

    if (!isHoveringClickable) {
      setRotation(rotation);
      setScaleX(0.2 + scale);
      setScaleY(0.2 - scale);
    }
  }

  function animate() {
    const speed = 0.35;
    pos.x += (targetPos.x - pos.x) * speed;
    pos.y += (targetPos.y - pos.y) * speed;
    vel.x = targetPos.x - pos.x;
    vel.y = targetPos.y - pos.y;
    update();
    requestAnimationFrame(animate);
  }

  window.addEventListener("mousemove", (e) => {
    targetPos.x = e.clientX;
    targetPos.y = e.clientY;
  });

  // Animation utility function
  function animateElement(element, properties, duration, easing = 'ease-out') {
    return new Promise(resolve => {
      const startValues = {};
      const changes = {};
      const startTime = performance.now();
      
      // Extract starting values and calculate changes
      for (const key in properties) {
        if (key === 'scale') {
          startValues[key] = parseFloat(getComputedStyle(element).getPropertyValue('transform').split(',')[0].slice(7)) || 0.2;
        } else if (key === 'rotation') {
          // We'll use our tracked value instead of trying to parse it
          startValues[key] = element === elasticCursor ? cursorTransform.rotate : 0;
        } else if (key === 'opacity') {
          startValues[key] = parseFloat(getComputedStyle(element).getPropertyValue('opacity') || 1);
        }
        changes[key] = properties[key] - startValues[key];
      }
      
      // Define easing functions
      const easingFunctions = {
        'linear': t => t,
        'ease-out': t => 1 - Math.pow(1 - t, 2),
        'power2.out': t => 1 - Math.pow(1 - t, 2),
        'elastic': t => {
          const p = 0.3;
          return Math.pow(2, -10 * t) * Math.sin((t - p/4) * (2 * Math.PI) / p) + 1;
        }
      };
      
      function animate(currentTime) {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / (duration * 1000), 1);
        const easedProgress = easingFunctions[easing] ? easingFunctions[easing](progress) : progress;
        
        // Apply animated values
        for (const key in properties) {
          const currentValue = startValues[key] + changes[key] * easedProgress;
          
          if (element === elasticCursor) {
            // For the main cursor element
            if (key === 'scale') {
              setScaleX(currentValue);
              setScaleY(currentValue);
            } else if (key === 'opacity') {
              elasticCursor.style.opacity = currentValue;
            }
          } else if (element === arrow) {
            // For the arrow element
            if (key === 'rotation') {
              element.style.transform = `rotate(${currentValue}deg)`;
            } else if (key === 'scale') {
              element.style.transform = `${element.style.transform.replace(/scale\([^)]*\)|$/, '')} scale(${currentValue})`;
              element.style.scale = currentValue; // Also set the scale property for browsers that support it
            }
          }
        }
        
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          resolve();
        }
      }
      
      requestAnimationFrame(animate);
    });
  }

  function handleCursorHover(isHover, element) {
    isHoveringClickable = isHover;

    // Scale the entire cursor
    animateElement(elasticCursor, {
      scale: isHover ? 2 : 0.2
    }, 0.3, 'power2.out');

    // Always reset the base cursor rotation when hovering
    if (isHover) {
      setRotation(0);
    }

    // Determine arrow behavior:
    if (isHover && element && element.classList.contains('d-btn')) {
      // If it's a .d-btn, show the arrow pointing down
      arrow.style.transformOrigin = 'center';
      animateElement(arrow, {
        rotation: 0,
        scale: 1
      }, 0.8, 'elastic');
    }
    else if (isHover && element === prevButton) {
      // Prev button: rotate arrow to point left
      arrow.style.transformOrigin = 'center';
      animateElement(arrow, {
        rotation: 90,
        scale: 1
      }, 0.8, 'elastic');
    }
    else if (isHover && element === nextButton) {
      // Next button: rotate arrow to point right
      arrow.style.transformOrigin = 'center';
      animateElement(arrow, {
        rotation: -90,
        scale: 1
      }, 0.8, 'elastic');
    }
    else {
      // Otherwise hide the arrow
      animateElement(arrow, {
        rotation: 0,
        scale: 0
      }, 0.3, 'ease-out');
    }
  }

  // bind hover to all links & buttons
  document.querySelectorAll('a, button').forEach(el => {
    el.addEventListener('mouseenter', () => handleCursorHover(true, el));
    el.addEventListener('mouseleave', () => handleCursorHover(false, null));
  });

  // fade cursor in/out on leave/enter window
  function hideCursor() { 
    elasticCursor.style.opacity = 0;
    elasticCursor.style.transition = 'opacity 0.7s';
  }
  
  function showCursor() { 
    elasticCursor.style.opacity = 1;
    elasticCursor.style.transition = 'opacity 0.7s';
  }

  document.addEventListener('mouseleave', hideCursor);
  document.addEventListener('mouseenter', showCursor);

  document.querySelectorAll('iframe').forEach(iframe => {
    iframe.addEventListener('mouseenter', hideCursor);
    iframe.addEventListener('mouseleave', showCursor);
  });

  if (!isTouchDevice) {
    animate();
  }
}

// expose public functions
window.initNav       = initNav;
window.customCursor  = customCursor;
window.scrollToIndex = scrollToIndex;